

export const home_copy = {
    "home.title": "The best music is shared",
    "home.desc": "A web application for DJs to analyse music shared on social media. Sign up and get a never ending feed of inspiration for your DJ sets.",
    "home.desc": "Audio Underground turns facebook posts into music playlists",
    // A web application for DJs to analyse music shared on social media. Sign up and get a never ending feed of inspiration for your DJ sets.

};
//Search for your favourite Artists, Record Labels, DJs and discover what music they share across social media. You can subscribe to your favoutite pages to get the latest music omn this page.<br/><br/>New to Audio Underground? Why not take a tour...<br/>


//Listen to rc303h | soundcloud is an audio platform that lets you listen to what you love and share the sounds you create.



// WEBPACK FOOTER //
// ./src/copy.js